// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ILLMZ","rightAdornment":"Header_rightAdornment__3R5t6"};